import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { SubSink } from 'subsink';
import { AccountService } from '../services/account.service';
import { ResetPasswordViewModel } from '../shared/models/update-account-view-model';
import { ToastService } from '../shared/toast/toast.service';

@Component({
  selector: 'pps-reset-password',
  templateUrl: './reset-password.component.html',
  styles: [
  ],
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
  private subs = new SubSink();

  items: MenuItem[] = [
    {label: "Admin", icon: "pi-fw fas fa-user-cog"},
    {label: "Manage Users", icon: "pi-fw fas fa-users", routerLink: ["/manage-user"]},
    {label: "Reset Password", icon: "pi-fw fas fa-user-lock"},
  ];

  resetPasswordViewModel: ResetPasswordViewModel = new ResetPasswordViewModel();
  updating: boolean = false;
  errorMessage: string = "";
  passwordReset: boolean = false;
  smallScreen: boolean = false;

  constructor(private _accountService: AccountService,
              private _toast: ToastService,
              private _route: ActivatedRoute,
              private _router: Router,
              private breakpointObserver: BreakpointObserver) {
    this.subs.sink = this.breakpointObserver.observe(['(min-width: 768px)'])
      .subscribe((state: BreakpointState) => {
        this.smallScreen = !state.matches;
      });    

  }
  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  ngOnInit(): void {
    this.subs.sink = this._route.queryParams.subscribe(param => {
      this.resetPasswordViewModel.zoesenUserId = param.userId;
      this.resetPasswordViewModel.userName = param.userName;
      this.resetPasswordViewModel.firstName = param.firstName;
      this.resetPasswordViewModel.lastName = param.lastName;
    });
  }

  resetPassword(userForm){
    if (this.resetPasswordViewModel.newPassword !== this.resetPasswordViewModel.confirmPassword){
      userForm.controls["confirmPassword"].setErrors({"notmatch": true});
      return;
    }

    if (this.resetPasswordViewModel.newPassword){
      if (!/(?=.*[a-z])/g.test(this.resetPasswordViewModel.newPassword)){
        userForm.controls["newPassword"].setErrors({"nolowercase": true});
        return;
      }

      if (!/(?=.*[A-Z])/g.test(this.resetPasswordViewModel.newPassword)){
        userForm.controls["newPassword"].setErrors({"nouppercase": true});
        return;
      }

      if (!/(?=.*\d)/g.test(this.resetPasswordViewModel.newPassword)){
        userForm.controls["newPassword"].setErrors({"nodigit": true});
        return;
      }

      if (!/(?=.*[-+_!@#$%^&*.,?])/g.test(this.resetPasswordViewModel.newPassword)){
        userForm.controls["newPassword"].setErrors({"nonalphanumeric": true});
        return;
      }
    }

    if (userForm.invalid){
      return;
    }

    this.updating = true;
    this.passwordReset = false;
    this.subs.sink = this._accountService.resetPassword({
        zoesenUserId: this.resetPasswordViewModel.zoesenUserId,
        userName: this.resetPasswordViewModel.userName,
        firstName: this.resetPasswordViewModel.firstName,
        lastName: this.resetPasswordViewModel.lastName,
        newPassword: btoa(this.resetPasswordViewModel.newPassword),
        confirmPassword: btoa(this.resetPasswordViewModel.confirmPassword)
      })
      .subscribe(res => {
        if (res.succeed){
          this.passwordReset = true;
          this._toast.succeeded("Password has been reset.");
        }else{
          this._toast.failed(`Failed to reset password`);
        }
      })
      .add(()=>{
        this.updating = false;
      });;
  }

  returnToUserManagement(){
    this._router.navigate(["/manage-user"], {replaceUrl: true});
  }

  gotoUserRoleManagement(){
    this._router.navigate(["/user-role-management"], {replaceUrl: true});
  }
}
